import React from 'react';
import { Box, Card, CardContent, Typography, Button, Container } from '@mui/material';
import { BlockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SchoolSuspended = () => {
  const navigate  = useNavigate();
  const tenantId  = localStorage.getItem('tenant_id');

  const handleContactSupport = () => {
    window.location.href = 'mailto:support@schoolsync.ac';
  };

  return (
    <Container maxWidth="sm">
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
        <Card sx={{ width: '100%', maxWidth: 460 }}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Box component="img" src="/Logo.png" alt="School Sync" sx={{ width: 70, height: 70, objectFit: 'contain', mb: 2 }} />

            <BlockOutlined sx={{ fontSize: 56, color: 'error.main', mb: 2 }} />

            <Typography variant="h5" fontWeight={700} color="error.main" gutterBottom>
              Account Suspended
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
              This school account has been suspended and is currently inaccessible.
            </Typography>

            {tenantId && (
              <Box sx={{ bgcolor: 'grey.100', borderRadius: 2, p: 1.5, mb: 3 }}>
                <Typography variant="body2" color="text.secondary">School ID</Typography>
                <Typography variant="body1" fontWeight={600}>{tenantId}</Typography>
              </Box>
            )}

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Please contact your platform administrator or School Sync support to resolve this.
            </Typography>

            <Button variant="contained" color="primary" onClick={handleContactSupport} sx={{ mb: 1.5 }} fullWidth>
              Contact Support
            </Button>

            <Button variant="text" color="inherit" onClick={() => navigate('/login')} fullWidth>
              Back to Login
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default SchoolSuspended;
